import React, { useEffect, useState, useRef } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import { resourcesReports, resourcesUnits } from "../../../helpers/backend_helper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import { getStorageUser } from "../../../helpers/api_helper";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import ButtonHelper from "../../../helpers/ButtonHelper";
import Select from "react-select";

const CombustiblePorUnidadReport = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${
    timeElapsed.getMonth() + 1 < 10 ? "0" : ""
  }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;
  const [date, setDate] = useState({ initDate: "", endDate: "" });
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "number",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateNow,
    endDate: dateNow,
    unit_id: null,
  });
  const [items, setItems] = useState([]);
  const [selects, setSelects] = useState({ units: [] });

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesReports("show", params, "combustibleUnidadReport").then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);
  const eleRef = useRef();

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesReports("show", config, "combustibleUnidadReport").then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte de combustible por unidad.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const units = await resourcesUnits("get", params);
      setSelects({
        ...selects,
        units: units.data,
      });
    };
    getSelects();
  }, []);

  const columns = Columns({filters});
  document.title = "Combustible por unidad | Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Reporte de Combustible por unidad"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              filterInp={false}
              setFilters={setFilters}
            >
              <ButtonHelper
                addButon={false}
                reportButons={true}
                actionReportButon={getReports}
                pdfButton={true}
              />
              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                getReports={getReports}
                modal={modal}
                setModal={setModal}
              />
              <div className="col-sm-2">
                <label className="form-label">Unidad:</label>
                <Select
                  style={{ padding: "01.25rem 0.5rem" }}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={false}
                  name="week"
                  value={selects.units.find(e => filters.unit_id==e.id) ?? null}
                  options={selects.units}
                  getOptionLabel={(option) => `${option.number}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setFilters({ ...filters, unit_id: e ? e.id : null }),
                  ]}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CombustiblePorUnidadReport;
